'use strict';

import _ from 'lodash';

const Errors = require('./../../services/Errors');
const StringLengthVerifierContrib = require('./../contribs/StringLengthVerifierContrib');
const Verifier = require('./../../system/Verifier');

module.exports = Verifier.define(StringLengthVerifierContrib, {
	type: 'MinecraftNameVerifier',

	lang: require('./MinecraftNameVerifierLang'),

	minLength: 1,
	maxLength: 16,

	init_MinecraftName: function(options) {
		this.options = _.defaults(options || {}, {
			checkWithMojang: true
		});
	},

	verify_mojang: function(name) {
		if (!this.options.checkWithMojang) {
			return;
		}

		return CK.clientSockets.users
			.emit('checkMinecraftName', {
				name
			})
			.then(() => {
				return true;
			})
			.catch(err => {
				if (err instanceof Errors.MinecraftNameInvalid) {
					throw err;
				}
			});
	}
});
